import React from "react";

const CreatePageForm = ({ pageTitle, setPageTitle, pageDesc, setPageDesc, onSubmit }) => {
  return (
    <div className="pb-card">
      <h2>Create Page</h2>
      <form onSubmit={onSubmit}>
        <label className="pb-label">Title</label>
        <input
          className="pb-input"
          value={pageTitle}
          onChange={(e) => setPageTitle(e.target.value)}
          placeholder="e.g. Process Development"
          required
        />

        <label className="pb-label">Description (optional)</label>
        <textarea
          className="pb-textarea"
          value={pageDesc}
          onChange={(e) => setPageDesc(e.target.value)}
          placeholder="Optional"
        />

        <button className="pb-button" type="submit">
          Create Page
        </button>
      </form>
    </div>
  );
};

export default CreatePageForm;